import * as React from 'react';
import styled from 'styled-components';

interface IStyleProps {
    margin?: string
};

const WhiteButton = styled.button`
    background: #ffffff;
    color: #005eb8;
    border-radius: 10px;
    padding: 6px 24px;
    min-height: 44px;
    font-size: 1.1rem;
    font-weight: bold;
    margin: ${(props: IStyleProps) => props.margin || "12px"};
    cursor: pointer;
    /* Doing disabled by class name so that we can still handle a click */
    &.disabled {
        opacity: 0.6;
    }
    &:focus {
        background: #fffee0;
    }
`;

interface IProps {
    disabled?: boolean,
    margin?: string,
    onClick?: () => void,
    onDisabledClick?: () => void,
    refProp?: React.RefObject<HTMLButtonElement>,
    submit?: boolean,
    text: string
};

const Button = (props: IProps) => {
    const { disabled, margin, onClick, onDisabledClick, refProp, submit, text } = props;

    const handleClick = (event: any) => {
        if (disabled) {
            event.preventDefault();
        }
        if (disabled && onDisabledClick) {
            onDisabledClick();
        }
        if (!disabled && onClick) {
            onClick();
        }
    };

    return <WhiteButton ref={refProp} type={submit ? "submit" : "button"} margin={margin} onClick={handleClick} className={disabled ? "disabled" : ""}>
        {text}
    </WhiteButton>;
};

export default Button;



// WEBPACK FOOTER //
// ./src/SharedComponents/Button.tsx